import React from 'react';

import { PropertyField, Section, ValueGroup } from 'craft/containers/Toolbox/components';
import { useMultiNodes } from 'craft/hooks';
import { EditingMode, PropToEdit } from 'craft/types';

interface Props {
  nodeIds: string[];
}

export const GenericProperties = ({ nodeIds }: Props) => {
  const { props } = useMultiNodes(nodeIds);

  // Find generic props
  const propsToEdit = Object.keys(props || {})?.reduce((accum, propId) => {
    const { schema, value } = props[propId];
    if (schema.id !== 'children' && schema.editingMode !== EditingMode.Custom) {
      accum.push({
        schema,
        value,
      });
    }

    return accum;
  }, [] as PropToEdit[]);

  // Group generic props preserving order
  const propsToEditGrouped = propsToEdit?.reduce((groups, prop) => {
    const groupName = prop.schema.group || '';
    if (!groups.has(groupName)) {
      groups.set(groupName, []);
    }
    groups.get(groupName)?.push(prop);
    return groups;
  }, new Map<string, PropToEdit[]>());

  if (propsToEdit.length < 1) {
    return null;
  }

  return (
    <Section name="Properties" data-cy="toolbox-section-properties">
      {Array.from(propsToEditGrouped)?.map(([groupName, groupProps]) => (
        <ValueGroup key={groupName} label={groupName}>
          {groupProps?.map((propToEdit) => (
            <PropertyField key={propToEdit.schema.id} nodeIds={nodeIds} propToEdit={propToEdit} />
          ))}
        </ValueGroup>
      ))}
    </Section>
  );
};
